export default __webpack_public_path__ + "static/1061-4a6fafb04c3fd516375008f978f921d0.gif";